module.exports = "/* You can add global styles to this file, and also import other style files */\nhtml {\n  overflow-y: hidden !important;\n}\n"